exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading {\r\n    padding: 5px 15px;\r\n}\r\n\r\n.panel-footer {\r\n\tpadding: 1px 15px;\r\n\tcolor: #A0A0A0;\r\n}\r\n\r\n.profile-img {\r\n\twidth: 96px;\r\n\theight: 96px;\r\n\tmargin: 0 auto 10px;\r\n\tdisplay: block;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.btn_login {\r\n  background-color:#78D5E3;\r\n  border: 1px solid #78D5E3;\r\n}\r\n.btn_login:hover {\r\n  background-color:#78D5E3;\r\n  border: 1px solid #78D5E3;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/sign-up/sign-up.component.css
// module id = ../../../../../src/app/sign-up/sign-up.component.css
// module chunks = 2